import { Component, OnInit, AfterViewInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-generic-tabs-v2',
    templateUrl: './generic-tabs-v2.component.html',
    styleUrls: ['./generic-tabs-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericTabsV2Component implements OnInit, AfterViewInit {

  @Input() configData;
  @Input() frmGroup;

  constructor(private appService: AppService) { }
  ngAfterViewInit(): void {}

  ngOnInit(): void {
    // console.log("hi", this.frmGroup, this.configData)
  }
  getColsClass(cols: number[], control?: any) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }
    if (control && navigator.userAgent.toLowerCase().indexOf("mobile") > -1) {   // hard coded
      if (control && control["component"] == "SEARCHBOX_V2" && control["name"] == "SearchBox") {
        colsClass += "makeDwarf searchBoxMobileView";
      }
      if (control && control["component"] == "FORM_FILTER_V2" && control["name"] == "formFilter") {
        colsClass += "makeDwarf formFilterMobileView";
      }
    }
    if (control && control.hasOwnProperty("makeDwarf") && control.makeDwarf) {
      colsClass += 'dwarf' + ' ';
    }
    return colsClass;
  }

  //CP-9514 - start
  checkSectionAccess(group, tabIndex, grpIndex = null) {
    if (group.editAccess) {
      group.editAccess.forEach(row => {
        let persona;
        if (row.roleAccess) {
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }
        if (grpIndex && this.configData.tabs[tabIndex].groups[grpIndex - 1].visibility === false) {//if previous section is also hidden
          group.showDividerLine = false;
        }
        if (row.action == 'hidden' && !this.checkFieldAccess(persona)) {
          group.visibility = false;
          return false;
        }
      });
      return true;
    }
    else if (grpIndex && this.configData.tabs[tabIndex].groups[grpIndex - 1].visibility === false) {//if previous section is also hidden
      group.showDividerLine = false;
      return true;
    }
    else {
      return true;
    }
  }

  // Method to check if the logged in user is having access of mentioned persona
  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }
  //CP-9514 - end

  // CP-8952 Send groupLevelAction data to parent component
  groupLevelActionData(actiondata, index) {
    this.sendToSource(actiondata, index)
  }

  sendToSource(event, index) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType || 'MULTIPLE_ACTION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: this.frmGroup.get(this.configData.name).value
    }
    eventData['tabIndex'] = index;
    console.log("eventData:::",eventData);
    this.appService._commonComponentSubject.next(eventData);
  }
}

